/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon20Light = forwardRef('ArrowDim2DiagMinRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m12.707 8 5.147-5.146a.5.5 0 0 0-.708-.708L12 7.293V3a.5.5 0 0 0-1 0v4.5A1.5 1.5 0 0 0 12.5 9H17a.5.5 0 0 0 0-1h-4.293Z" }),
        React.createElement("path", { d: "M8 17v-4.293l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 12H3a.5.5 0 0 1 0-1h4.5A1.5 1.5 0 0 1 9 12.5V17a.5.5 0 0 1-1 0Z" })));
});
